import React from 'react';

const GoogleMap = () => {
  return (
    <div style={{ width: '100%', height: '150px', margin: '20px auto' }}>
      <iframe
        title='Google Map'
        width='100%'
        height='100%'
        style={{ border: 0 }}
        loading='lazy'
        allowFullScreen
        src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.383593525797!2d78.57844587408755!3d10.781904259094578!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3baa5e10e4cf0ec9%3A0xa23c4972f5528dc7!2sICAR-National%20Research%20Centre%20for%20Banana!5e0!3m2!1sen!2sin!4v1724414431044!5m2!1sen!2sin'
      >
      </iframe>
    </div>
  );
};

export default GoogleMap;
